import CONSTANTS from "../Constants/fleetOverview";

export const fetchOneScore = (params) => ({
    type: CONSTANTS.FETCH_ONE_SCORE
});
  